import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { AuthRouteKeys } from 'routes/enums';
import { useLogoutMutation } from 'services';
import { handleLogout as handleLogoutUtils } from 'utils/helpers';

const LogoutFeature = () => {
  const { mutateAsync } = useLogoutMutation();

  const navigate = useNavigate();

  useEffect(() => {
    const handleLogout = async () => {
      try {
        await mutateAsync();
        handleLogoutUtils();
        toast.success('Đăng xuất thành công');
        navigate(AuthRouteKeys.Login);
      } catch {
        // End the local session even when the server logout request fails.
        handleLogoutUtils();
        navigate(AuthRouteKeys.Login);
      }
    };

    void handleLogout();
  }, [mutateAsync, navigate]);

  return null;
};

export default LogoutFeature;
